import { DWImage } from 'src/components/image';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWImage.displayName, DWImage);

export default DWImage;

export { DWImage };
